<template>
  <div class="h-100">
    <div class="row">
      <div class="col-md-12 h-100">
        <ValidationObserver key="" ref="form" v-slot="{}">
          <div class="row d-flex justify-content-between">
            <div class="col-6 col-md-4"></div>
            <div class="col-md-4 d-flex justify-content-end">
              <button
                class="btn btn-filter btn-icon ml-4"
                type="button"
                @click.prevent.stop="showFilterModal"
              >
                <span class="icon icon-filter" /> {{ $t('filter') }}
              </button>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>

    <div class="row h-100">
      <div class="col-md-12">
        <div v-if="isLoaded">
          <div class="">
            <div v-cloak v-if="!habilitationsList.length">
              <div class="box-block mt-4">
                <div class="alert alert-primary">
                  {{ $t('emptyHabilitationsList') }}
                </div>
              </div>
            </div>
            <div v-else v-cloak class="dates dates_users">
              <habilitation-table
                :habilitationsList="habilitationsList"
              ></habilitation-table>
              <div v-if="!isFiltrSelected">
                <div class="row mt-3 mb-5">
                  <div
                    class="col-sm-12 d-flex justify-content-between"
                    v-if="totalPages > 1"
                  >
                    <div class="">
                      <button
                        class="btn btn-filter btn-icon"
                        @click="previousPage()"
                      >
                        <span class="icon icon-arrow-left" />
                        {{ $t('previous') }}
                      </button>
                    </div>
                    <div>{{ $t('pagination', [page, totalPages]) }}</div>
                    <div class="">
                      <button
                        class="btn btn-filter btn-icon"
                        @click="nextPage()"
                      >
                        {{ $t('next') }} <span class="icon icon-arrow-right" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="h-100">
          <div
            class="h-100 row d-flex justify-content-center align-items-center"
          >
            <div class="col-12">
              <div class="d-flex justify-content-center align-items-center">
                <div class="spinner-border" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <confirmation-modal></confirmation-modal>
    <FilterModal />
  </div>
</template>

<script>
import FilterModal from '@/js/components/Profile/habilitations/FilterModal.vue'
import ConfirmationModal from '@/js/components/modals/ConfirmationModal.vue'
import HabilitationRow from './HabilitationRow.vue'
import HabilitationTable from './HabilitationTable.vue'
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'TraineeHabilitations',
  components: {
    ConfirmationModal,
    HabilitationRow,
    HabilitationTable,
    FilterModal,
  },
  data() {
    return {
      page: 1,
      q: '',
      habilitationsList: [],
      form: {
        firstname: null,
        lastname: null,
        birthday: null,
        email: null,
        gender: 0,
      },
      isLoaded: false,
      locale: '',
      monitor: {
        visible: false,
        message: '',
        type: 'text-warning',
      },
    }
  },
  computed: {
    ...mapFields(['user', 'establishment']),
    ...mapFields([
      'traineeHabilitations.habilitations',
      'traineeHabilitations.pagination',
      'traineeHabilitations.limit',
      'traineeHabilitations.isFiltrSelected',
    ]),
    clientType() {
      return this.$lodash.get(this.user, 'clientType', false)
    },
    totalPages() {
      return this.$lodash.get(this.pagination, 'total_pages', 1)
    },
  },
  watch: {
    page: (val) => {
      if (val < 1) {
        this.page = 1
      }
    },
    $route: {
      handler(to, from) {
        if (this.$lodash.get(this.$route, 'query', false)) {
          let a = {
            ...this.$route.query,
            ...{
              page: this.$route.query.page || 1,
              limit: this.$route.query.limit || this.limit,
            },
          }
          this.getHabilitations(a)
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.isFiltrSelected = false
    this.locale = this.user.local
    this.$bus.$on('update-habilitations-list', (toStart = true) => {
      let a = {
        ...this.$route.query,
        ...{
          page: !toStart && this.$route.query.page ? this.$route.query.page : 1,
          limit: this.limit,
        },
      }
      this.getHabilitations(a)
    })
    this.$bus.$on('filter-habilitations', (data) => {
      this.filter(data).then(() => {
        this.$bus.$emit('hide-filter-habilitation-modal')
      })
    })
  },
  beforeMount() {
    this.$bus.$off('update-habilitations-list')
    this.$bus.$off('filter-habilitations')
  },
  methods: {
    showFilterModal() {
      this.$bus.$emit('filter-habilitation-modal.show')
    },
    nextPage() {
      if (
        this.pagination.total_pages > 1 &&
        this.page < this.pagination.total_pages
      ) {
        this.page++
        let a = {
          ...this.$route.query,
          ...{ page: this.page, limit: this.limit },
        }
        this.$router
          .push({ name: 'Habilitations', query: a })
          .catch((error) => {})
      }
    },
    previousPage() {
      if (this.pagination.total_pages > 1 && this.page > 1) {
        this.page--
        let a = {
          ...this.$route.query,
          ...{ page: this.page, limit: this.limit },
        }
        this.$router
          .push({ name: 'Habilitations', query: a })
          .catch((error) => {})
      }
    },
    filter(params) {
      this.isLoaded = false
      let payload = {
        params,
      }
      return this.$store
        .dispatch('traineeHabilitations/searchHabilitations', payload)
        .then((response) => {
          this.habilitationsList = this.habilitations
        })
        .finally(() => {
          this.isLoaded = true
          this.isFiltrSelected = true
        })
    },
    search() {
      if (this.q != '') {
        this.isLoaded = false
        let payload = {
          params: {
            action: 'search',
            q: this.q,
          },
          id: this.user.id,
        }
        this.$store
          .dispatch('traineeHabilitations/searchHabilitations', payload)
          .then((response) => {
            this.habilitationsList = this.habilitations
          })
          .finally(() => {
            this.isLoaded = true
            this.isFiltrSelected = true
          })
      } else {
        this.isFiltrSelected = false
        let a = { ...this.$route.query, ...{ page: 1, limit: this.limit } }
        this.getHabilitations(a)
      }
    },
    getHabilitations(params) {
      this.isLoaded = false
      this.$store
        .dispatch('traineeHabilitations/getHabilitations', params)
        .then(() => {
          this.habilitationsList = this.habilitations
        })
        .finally(() => {
          this.isLoaded = true
        })
    },

    monitorHide() {
      this.monitor.type = ''
      this.monitor.message = ''
      this.monitor.visible = false
    },
  },
}
</script>

<style></style>
